import { TableColumn } from "PFApp/components/table/table_types";
import { DropdownOption } from "PFComponents/dropdown/dropdown";
import { TablePagination } from "PFComponents/table/table_pagination";
import { SkillsFrameworksResponse } from "PFCore/services/admin/skills_frameworks/fetch_skills_frameworks";
import React from "react";

import { SkillsFrameworksColumnsHeaders } from "./skills_frameworks_columns_headers";
import { SkillsFrameworksRows } from "./skills_frameworks_rows";
import css from "./skills_frameworks_table.module.scss";

type SkillsFrameworksTableProps = {
  actions: DropdownOption[];
  skillsFrameworks: SkillsFrameworksResponse;
  columns: TableColumn[];
  setPage: (page: number) => void;
};

export const SkillsFrameworksTable = ({
  actions,
  columns,
  setPage,
  skillsFrameworks
}: SkillsFrameworksTableProps) => {
  const { totalPages, page } = skillsFrameworks.meta;
  return (
    <>
      <div className={css.scrollWrapper}>
        <div className={css.list}>
          <SkillsFrameworksColumnsHeaders skillsFrameworks={skillsFrameworks} columns={columns} />
          <SkillsFrameworksRows actions={actions} skillsFrameworks={skillsFrameworks} columns={columns} />
        </div>
      </div>
      <TablePagination paginationOptions={{ currentPage: page, totalPages, onClick: setPage }} />
    </>
  );
};
